import { render, staticRenderFns } from "./personal_data_tab.vue?vue&type=template&id=00c2508a&scoped=true"
import script from "./personal_data_tab.vue?vue&type=script&lang=js"
export * from "./personal_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2508a",
  null
  
)

export default component.exports